// Primero la letra y los estilos base: así los de cada pantalla (que se importan con ella) van detrás y mandan.
// Inter (variable), servida desde Anota: la letra de la interfaz, igual en todos los sistemas.
import "@fontsource-variable/inter";
import "./styles.css";
import { StrictMode } from "react";
import { startPwa } from "./pwa";
import { createRoot } from "react-dom/client";

// Las páginas: la portada (/), la bandeja de notas (/notas), una invitación (/invitacion/inv_…) y el
// portal del cliente (/portal#…).
// El Worker sirve index.html en cualquier ruta.
const path = location.pathname.replace(/\/+$/, "");
const invitation = /^\/invitacion\/(inv_[A-Za-z0-9]{32})$/.exec(path)?.[1];
if (path === "/notas") document.title = "Bandeja · Anota";
if (invitation) document.title = "Invitación · Anota";
if (path === "/portal") document.title = "Tus notas · Anota";

// La app instalable (PWA y APK): service worker, versiones nuevas y «Instalar la app».
startPwa();

const page =
  path === "/notas"
    ? import("./inbox/Inbox").then(({ Inbox }) => <Inbox />)
    : path === "/portal"
      ? import("./inbox/Portal").then(({ Portal }) => <Portal />)
      : invitation
        ? import("./inbox/Invitation").then(({ Invitation }) => <Invitation token={invitation} />)
        : import("./App").then(({ App }) => <App />);
void page.then((p) => createRoot(document.getElementById("root")!).render(<StrictMode>{p}</StrictMode>));
